import { INCORRECT_PASS } from '#constants/errors';

export const isIncorrectPassError = error =>
  error.internal_code === INCORRECT_PASS.internalMessage && error.message === INCORRECT_PASS.message;
